import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl font-semibold text-white mb-4">
              MULTIDIO
            </h3>
            <p className="text-white/50 text-sm leading-relaxed mb-4">
              Stone on Glass. Art designed for public spaces. Modern, simple, clean, yet warm because of the natural stone.
            </p>
            <p className="font-heading text-lg italic text-teal-400">
              by Jim Richardson
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-white mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col space-y-3">
              <Link 
                to="/" 
                className="text-white/50 hover:text-teal-400 transition-colors text-sm"
                data-testid="footer-home"
              >
                Home
              </Link>
              <Link 
                to="/portfolio" 
                className="text-white/50 hover:text-teal-400 transition-colors text-sm"
                data-testid="footer-portfolio"
              >
                Portfolio
              </Link>
              <Link 
                to="/about" 
                className="text-white/50 hover:text-teal-400 transition-colors text-sm"
                data-testid="footer-about"
              >
                About
              </Link>
              <Link 
                to="/contact" 
                className="text-white/50 hover:text-teal-400 transition-colors text-sm"
                data-testid="footer-contact"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs uppercase tracking-widest font-semibold text-white mb-6">
              Contact
            </h4>
            <div className="flex flex-col space-y-4">
              <a 
                href="mailto:richardsonjim@gmail.com" 
                className="flex items-center space-x-3 text-white/50 hover:text-teal-400 transition-colors text-sm"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4" />
                <span>richardsonjim@gmail.com</span>
              </a>
              <div className="flex items-center space-x-3 text-white/50 text-sm">
                <MapPin className="h-4 w-4" />
                <span>Victoria, BC, Canada</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-center text-white/30 text-xs">
            &copy; {new Date().getFullYear()} MULTIDIO by Jim Richardson. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
